module.exports = __webpack_public_path__ + "img/bateria.5786d3a4.jpg";